import axios from "axios";

const BASE_URL = "https://live.api.bigfivecrm.com/";
// const WEBDATA_URL = "api/v2/webdata"; // Sub URL for sending data
const LEAD_URL = "api/v2/contact-us"
export const axioscrmInstance = axios.create({
  baseURL: " https://live.api.bigfivecrm.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    AuthToken: `Bearer b25ib2FyZGluZ2FwaUBiaWdmaXZlY3JtLmNvbTpzZXJpb3VzMjNhJCMkRkQqI0ZBT1NJREYjKCkqI1dIRkEpKFJVKSgjUUpGU0E=`,
  },
});

const KNOWLEDGE_BASE_API = "/api/v2/articles";

export const KnowledgeBaseApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(KNOWLEDGE_BASE_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};

export const submitFormAPI = async (data) => {
    try {
      const response = await axios.post(`${BASE_URL}${LEAD_URL}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };